// routes
import { paths } from 'src/routes/paths';
// utils
import { isWebCallingEnabled } from 'src/utils/assigned-tasks/calling-access';
import { normalizeRole, resolveEffectiveRole } from 'src/utils/roles';

// API
// ----------------------------------------------------------------------

export const HOST_API = process.env.REACT_APP_HOST_API;
export const ASSETS_API = process.env.REACT_APP_ASSETS_API;

// Where a volunteer belongs. Assigned Tasks only when the selected organization itself says
// volunteer *and* is in WEB_CALLING_ENABLED_ORG_IDS; otherwise voter search. That includes a
// `user` that is merely the global-role fallback (no organization resolved). Legislative tenants
// have no calling volunteers, so those land on constituent search. Accepts a raw org role code
// (owner/volunteer) or an already-normalized one. Voter search here is the rebuilt search screen
// the volunteer menu links to, not the classic list at the section root.
export const volunteerHomePath = (orgRole, isLegislative = false, organizationId = undefined) => {
  if (isLegislative) return paths.voters.legSearch;
  return normalizeRole(orgRole) === 'user' && isWebCallingEnabled(organizationId)
    ? paths.assignedTasks.root
    : paths.voters.search;
};

// ROOT PATH AFTER LOGIN SUCCESSFUL
// `orgRole` and `organizationId` are the *selected* organization's — see HomeRedirect in
// src/routes/sections/index.js, which waits for them before calling this.
export const PATH_AFTER_LOGIN = (
  globalRole,
  orgRole,
  isLegislative = false,
  organizationId = undefined
) => {
  // Accepts a raw org role code (owner/volunteer) or an already-normalized one.
  const effectiveRole = resolveEffectiveRole(globalRole, orgRole);
  if (effectiveRole === 'superadmin') return paths.superadmin.orgs;
  if (effectiveRole === 'national_viewer') return paths.reports.activity;
  // Not dashboard.root: that is the Command Center, which ManagerDashboardGuard bounces
  // straight to campaigns for anyone who isn't superadmin/legislative. Landing there would
  // cost every manager login a blank render and a second redirect.
  if (effectiveRole === 'manager') return paths.dashboard.campaigns;
  if (effectiveRole === 'legislative_member') return paths.voters.legSearch;
  return volunteerHomePath(orgRole, isLegislative, organizationId);
};
